<template>
  <div>
    <div class="row">
      <div class="col-12">
        <router-link :to="{ name:'AdminContactsAdd' }" class="btn btn-success">
          <i class="fa fa-edit" aria-hidden="true"></i> Add Contact
        </router-link>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-12">
        <table class="table table-striped">
          <thead class="bg-hub-primary text-white">
            <tr>
              <th>Name</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Recieves</th>
              <th>Manage</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="contact in contacts" :key="contact.contact_id">
              <td>{{ contact.name }}</td>
              <td>{{ contact.phone_number }}</td>
              <td>{{ contact.email }}</td>
              <td>
                <ul>
                  <li v-if="contact.daily_device_report">Daily device reports</li>
                  <li
                    v-if="contact.device_fail_reg_notification"
                  >Device failed registration notifications</li>
                  <li v-if="contact.all_alerts_sms">All alerts SMS</li>
                </ul>
              </td>
              <td>
                <div class="dropdown">
                  <button
                    class="btn btn-light dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="fa fa-cogs fa-fw" aria-hidden="true"></i>
                  </button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <router-link
                      :to="{ name:'AdminContactsEdit', params: { contact_id: contact.contact_id } }"
                      class="dropdown-item"
                    >
                      <i class="fa fa-pencil-alt fa-fw" aria-hidden="true"></i>&nbsp;Edit
                    </router-link>
                    <a
                      class="dropdown-item"
                      href="#"
                      onclick="return false"
                      @click="deleteContact(contact)"
                    >
                      <i class="fa fa-trash fa-fw" aria-hidden="true"></i>&nbsp;Delete
                    </a>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'adminContacts',
  computed: {
    ...mapGetters({
      contacts: 'allContacts',
      logged_in_user: 'loggedInUser',
      scoped_site_id: 'scopedSiteId'
    })
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', false)
    this.$store.dispatch('getContacts')
  },
  watch: {
    scoped_site_id (newScopedSiteId, oldScopedSiteId) {
      this.$store.dispatch('getContacts')
    }
  },
  methods: {
    ...mapActions(['deleteContact'])
  }
}
</script>

<style scoped>
</style>
